export const RiskTelemetrySourceTag = 'risk_experience_source';
export const RiskTelemetrySurfaceTag = 'risk_experience_surface';
// No keys that would contain PII should be included in this list.
// Read this doc for more details before making changes:
// https://trailhead.corp.stripe.com/docs/frontend/analytics-event-logger
export const riskFormAnalyticsAllowList = [
    // Shared
    RiskTelemetrySourceTag,
    RiskTelemetrySurfaceTag,
    'risk_experience_linked_model_token',
    // User task CTA
    'risk_experience_task_name',
    // Forms
    'all_questions_are_hidden',
    'is_obo',
    'risk_experience_form_name',
    'risk_experience_form_question_name',
    'risk_experience_form_source',
    'risk_experience_form_identifier_type',
    'risk_experience_form_identifier_value',
    // Deep link launcher
    'risk_experience_resolution_path',
    // Legacy - prefer to rename to risk_experience prefixed keys
    // The prefix helps with the allow-lists being organized and accountable
    'dashboard_form_id',
    'fetch_remote',
    'requirement_id',
    'resolution_path',
    'task_name',
    'time',
    // Page view tracking (for multi-page forms & informational pages)
    'risk_form_page',
    // For multi-forms
    // We skip pages that either have a hidden question set or all hidden questions
    'is_multi_page_form',
    'form_contains_ark_lib_powered_text_input',
    // These are for changing pages in multi-page forms (clicking on Continue or Back)
    'current_page_index',
    'new_page_index',
    // Page type
    'start_page_type',
    'end_page_type',
    // Challenge
    'challenge_type',
    'sub_challenge_type',
    'challenge_version',
    'identity_verification_source',
    // Error
    'error_code',
    'http_status'
];

//# sourceMappingURL=types.js.map